import { IDrawable } from "./Drawable/IDrawable";
import { IUpdateable, UpdateContext } from "./IUpdateable";

export abstract class Component implements IDrawable, IUpdateable {

    protected children: Array<Component> = [];

    update(context: UpdateContext): void {

        this.children.forEach(child => child.update(context));
    }

    draw(ctx: CanvasRenderingContext2D): void {
        ctx.save();
        this.children.forEach(child => child.draw(ctx));
        ctx.restore();
    }

}
